<template>
    <ul class="yy-dropdown-menu"><slot></slot></ul>
</template>
<script>
    export default {
        name: 'YYDropdownMenu'
    }
</script>
